<template>
	<!-- Keeps the pre-split root: the `v-if` (no results rendered nothing) and
	the classes callers' fallthrough lands on. -->
	<div
		v-if="products.length"
		v-editable="blok"
		class="flex flex-wrap relative flex-1"
	>
		<ProductRecommendationList
			class="w-full"
			:products="products"
			:title="blok.title"
			:title-styles="titleStyles"
			:title-tag="titleTag"
			:is-carousel="blok.is_carousel"
			:show-arrows="blok.show_arrows"
			:show-add-to-cart="blok.show_add_to_cart"
			@product-click="trackProductClick"
		/>
	</div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";
import type { BlokProductRecommendations } from "~/types/storyblok/storyblok";
import type { RecommendationContext } from "~/layers/base/composables/useProductRecommendations";
import { blockMeiliQuery } from "~/utils/product/recommendations";

// Builds the PDP/category context; fetching lives in the composable, markup in
// ProductRecommendationList.
const { selectedProduct } = storeToRefs(useProductStore());
const requestURL = useRequestURL();
const config = useRuntimeConfig();
const { titleTag } = useProductRecommendationsConfig();

const { hierarchies, blok } = defineProps<{
	blok: BlokProductRecommendations;
	titleStyles?: string;
	hierarchies?: string[][];
}>();

const context = computed<RecommendationContext>(() => {
	if (selectedProduct.value?.PartNo) {
		return { productNumbers: [selectedProduct.value.PartNo] };
	}

	if (hierarchies?.length) {
		return { urls: [requestURL.href], hierarchies };
	}

	return {};
});

const { products, trackProductClick } = useProductRecommendations({
	scope: "block",
	productBoxKey: () => blok.product_box_key,
	context,
	limit: () => blok.products_limit,
	// The PDP/category surface has a product to anchor the fallback on.
	meili: () =>
		blockMeiliQuery(
			blok,
			selectedProduct.value,
			config.public.norce.searchEngine
		)
});
</script>
